import { render, staticRenderFns } from "./CallerVerifyFooter.vue?vue&type=template&id=b02635dc&scoped=true"
import script from "./CallerVerifyFooter.vue?vue&type=script&lang=js"
export * from "./CallerVerifyFooter.vue?vue&type=script&lang=js"
import style0 from "./CallerVerifyFooter.vue?vue&type=style&index=0&id=b02635dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02635dc",
  null
  
)

export default component.exports